export default __webpack_public_path__ + "static/Fellix-LightItalic-f287e9cd7803059c43507756d4e76834.otf";